export default __webpack_public_path__ + "static/media/wreckarmor3.f5fb1d8f.png";